import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#fff"
        d="M10 2.667H3.333v10.666h9.334v-8H10V2.668zm-8-.672c0-.366.298-.662.666-.662h8L14 4.668v9.328a.666.666 0 01-.662.672H2.662A.666.666 0 012 14.005V1.995zm5.333 5.338h1.334v4H7.333v-4zm0-2.666h1.334V6H7.333V4.667z"
      ></path>
    </svg>
  )
}

export default Icon
